export default __webpack_public_path__ + "static/media/howto-img-01@medium.33ee20f3.jpg";